import {
  BillStatus,
  BillType,
  BillComplianceRule,
} from '@rematter/frontend-lib-api-client';

import { createQueryHook } from '~/shared/providers/api';

export const useBillStatusCountsQuery = createQueryHook(
  'finance.billStatusCounts',
  (params?: {
    types?: BillType[];
    statuses?: BillStatus[];
    compliance?: BillComplianceRule[];
    accountIDs?: string[];
    searchTerm?: string;
  }) => ({
    billStatusCounts: {
      __args: {
        filter: params
          ? {
              types: params.types,
              statuses: params.statuses,
              compliance: params.compliance,
              accountIDs: params.accountIDs,
              searchTerm: params.searchTerm,
            }
          : undefined,
      },
      pending: true,
      paid: true,
      voided: true,
    },
  }),
);
